import { ReactNode } from 'react'
import { PartnerService } from '@duck/api-definitions'
import { useTar } from '@/modules'
import { OrgWordmark } from '@/components/OrgWordmark'

interface InviteHeroCandidateProps {
  organizationName: string
  logoURL?: string | null
  logoCanvas?: PartnerService.OrganizationLogoCanvas | null
  /** Optional override for the headline. Defaults to the candidate-flow headline. */
  headline?: ReactNode
  /** Optional override for the subtitle. Defaults to "Create your account to continue". */
  subtitle?: ReactNode
}

export const InviteHeroCandidate = ({ organizationName, logoURL, logoCanvas, headline, subtitle }: InviteHeroCandidateProps) => {
  const { t } = useTar()
  const initial = organizationName.trim().charAt(0).toUpperCase() || '·'
  const hasWordmark = !!logoURL
  const resolvedHeadline = headline ?? t('invite.signup.headlineCandidate', { organizationName })

  return (
    <header className="text-center space-y-3">
      <div className="flex justify-center">
        {hasWordmark ? (
          <OrgWordmark
            org={{ name: organizationName, logoURL, logoCanvas: logoCanvas ?? undefined }}
            className="max-h-12 max-w-56 m-0"
          />
        ) : (
          <div
            className="h-11 w-11 rounded-lg bg-primary/10 ring-1 ring-primary/30 flex items-center justify-center"
            aria-hidden
          >
            <span className="text-base font-semibold text-primary select-none" translate="no">
              {initial}
            </span>
          </div>
        )}
      </div>
      <h1 className="text-2xl font-semibold leading-tight">{resolvedHeadline}</h1>
      <p className="text-sm text-muted-foreground">{subtitle ?? t('invite.signup.subtitle')}</p>
    </header>
  )
}
